<!-- <h1>Comp Renewal Premium Info</h1> -->
<div class="PremiumInfo">
        <!-- <div class="Loading" *ngIf="isShowLoading==true">
            <img id="" src="assets/img/762.gif" />
            <label>{{'Please Wait,Processing..' | translate }}</label>
        </div>     -->
        <div class="Loading" *ngIf="isShowLoading==true">
            <div class="loader"></div>
            <!-- <img id="" src="assets/img/762.gif"   /> -->
            <label class="loaderlabel">Please wait while Processing....</label>
        </div>  
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div style="width:100%;" id="InsuredInfo">
                <ul class="nav nav-tabs listdata" role="tablist">
                    <li role="presentation" class="active">
                        <a class="premiumdetailsheading" href="#home" aria-controls="home" role="tab" data-toggle="tab"> {{'Premium Details' | translate}}</a>
                    </li>    
                </ul>
                <div class="tab-content">
                    <div role="tabpanel" class="tab-pane active" id="home">
                        <div class="payFormUpgrade">   
                            <div class="row">
                                <div class="card upgradecard col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    
                                        <ul class="nav nav-tabs Sublistdata" role="tablist">
                                            <li role="presentation" class="active">
                                                <a href="#home" aria-controls="home" role="tab" data-toggle="tab">
                                                {{'Comprehensive Price in SAR' | translate }} </a>    
                                            </li>    
                                        </ul>
                                        <div class="tab-content">
                                            <div role="tabpanel" class="tab-pane active PolicyInfo Premium">    
                                                <!-- <label class="cardfeildupgrade">
                                                    <span class="lbltext"> {{'Basic Premium' | translate }}:</span>
                                                    <span>{{ objCheckEligibilityRes.BASIC_PREMIUM | number : '1.2-2' }}</span>
                                                </label> -->
                                                <label class="cardfeildupgrade" *ngIf="objSelectedCovers.PAB>0">
                                                    <span class="lbltext"> {{'PAB' | translate }}:</span>
                                                    <span class="lblvalue">{{ objSelectedCovers.PAB | number : '1.2-2' }}</span>
                                                </label>
                                                <!-- START of Additional Covers  -->
                                                <label class="cardfeildupgrade" *ngIf="objSelectedCovers.DAB>0">
                                                    <span class="lbltext"> {{'DAB' | translate }}:</span>
                                                    <span class="lblvalue">{{ objSelectedCovers.DAB | number : '1.2-2' }}</span>
                                                </label>
                                                
                                                <label class="cardfeildupgrade" *ngIf="objSelectedCovers.BAHRAIN>0">
                                                        <span class="lbltext"> {{'BAHRAIN' | translate }}:</span>
                                                        <span class="lblvalue">{{ objSelectedCovers.BAHRAIN | number : '1.2-2' }}</span>
                                                </label>
                                                <label class="cardfeildupgrade" *ngIf="objSelectedCovers.Geographical_Inc_Bahrain>0">
                                                        <span class="lbltext"> {{'Geographical_Inc_Bahrain' | translate }}:</span>
                                                        <span class="lblvalue">{{ objSelectedCovers.Geographical_Inc_Bahrain | number : '1.2-2' }}</span>
                                                </label>
                                                <label class="cardfeildupgrade" *ngIf="objSelectedCovers.Geographical_EJL>0">
                                                        <span class="lbltext"> {{'Geographical_EJL' | translate }}:</span>
                                                        <span class="lblvalue">{{ objSelectedCovers.Geographical_EJL | number : '1.2-2' }}</span>
                                                </label>
                                                <label class="cardfeildupgrade" *ngIf="objSelectedCovers.ZERO_DEP>0">
                                                        <span class="lbltext"> {{'ZERO_DEP' | translate }}:</span>
                                                        <span class="lblvalue">{{ objSelectedCovers.ZERO_DEP | number : '1.2-2' }}</span>
                                                </label>
                                                <label class="cardfeildupgrade" *ngIf="objSelectedCovers.VEHICLE_REP>0">
                                                        <span class="lbltext"> {{'VEHICLE_REP' | translate }}:</span>
                                                        <span class="lblvalue">{{ objSelectedCovers.VEHICLE_REP | number : '1.2-2' }}</span>
                                                </label>

                                                <!-- END of Additional Covers-->
                                                <label class="cardfeildupgrade">
                                                    <span class="lbltext"> {{'Comprehensive Premium Excluding VAT' | translate }}:</span>
                                                    <span class="lblvalue">{{ objCheckEligibilityRes.TOTAL_AMOUNT_BEFORE_VAT_COMP | number : '1.2-2' }}</span>
                                                </label>
                                                <label class="cardfeildupgrade">
                                                    <span class="lbltext"> {{'VAT Amount' | translate }}:</span>
                                                    <span class="lblvalue">{{ objCheckEligibilityRes.VAT_AMOUNT_COMP | number : '1.2-2' }}</span>
                                                </label>
                                                <label class="cardfeildupgrade">
                                                    <span class="lbltext"> {{'Comprehensive Amount' | translate }}:</span>
                                                    <span class="lblvalue">{{ objCheckEligibilityRes.TOTAL_AMOUNT_COMP | number : '1.2-2' }}</span>
                                                </label>
                                                <label class="cardfeildupgrade">
                                                    <span class="lbltext"> {{'TPL Refund Amount' | translate }}:</span>
                                                    <span class="lblvalue">{{ objCheckEligibilityRes.TOTAL_REFUND_AMOUNT_TPL | number : '1.2-2' }}</span>
                                                </label>
                                                <label class="cardfeildupgrade">
                                                    <span class="lbltext"> {{'Upgrade Amount' | translate }}:</span>
                                                    <span class="lblvalue">{{ objCheckEligibilityRes.TOTAL_AMOUNT_UPGRADE | number : '1.2-2' }}</span>
                                                </label>
                                                <!-- <label style="color:red;">Total: 1684 SAR</label>  -->
                                                <div class="btncomprehensivediv row">
                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 addcoverdiv">
                                                        <button class="btn btn-primary addcovers" data-toggle="modal"
                                                        data-target="#AdditionalCoversModal">{{'Add More Covers' | translate }}</button>
                                                    </div>
                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 viewcoverdiv">
                                                        <span class="coversdisplay">
                                                            <a class="viewcovers" style="color: rgb(17, 173, 69);"
                                                            [routerLink]="" (click)="CoverViews()">{{'View Cover Details'| translate}}</a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>    
                                        </div>
                                
                                </div>
                                <div class="card upgradecard col-lg-6 col-md-6 col-xs-12 col-sm-12">
                                
                                        <ul class="nav nav-tabs Sublistdata" role="tablist">
                                            <li role="presentation" class="active">
                                                <a href="#home" aria-controls="home" role="tab" data-toggle="tab">
                                                    {{'Vehicle Info' | translate }} </a>    
                                            </li>    
                                        </ul>
                                        <div class="tab-content">
                                            <div role="tabpanel" class="tab-pane active PolicyInfo Premium">    
                                                <label class="cardfeildupgrade">
                                                    <span class="lbltext"> {{'Sequence No / Custom ID' | translate }}:</span>
                                                    <span>{{ objBindInfoRes.VehicleId }}</span>
                                                </label>
                                                <label class="cardfeildupgrade">
                                                    <span class="lbltext"> {{'Chasis No' | translate }}:</span>
                                                    <span>{{ objBindInfoRes.ChassisNo }}</span>
                                                </label>
                                                <label class="cardfeildupgrade" style="margin-top: 40px;">
                                                    <div class="beltupgrade white">
                                                        <span class="arabic-character">
                                                            <div class="FirstAr">{{objBindInfoRes.Vehicle_Fletter_Ar}}</div>
                                                            <div class="SecondAr">{{objBindInfoRes.Vehicle_Sletter_Ar}}</div>
                                                            <div class="ThirdAr">{{objBindInfoRes.Vehicle_Tletter_Ar}}</div>
                                                        </span>
                                                        <span class="arabic-number">{{objBindInfoRes.Vehicle_PlateNo}}</span>
                                                        <span class="english-number">{{objBindInfoRes.Vehicle_PlateNo}}</span>
                                                        <span class="english-character">
                                                            <div class="FirstEn">{{objBindInfoRes.Vehicle_Fletter_En}}</div>
                                                            <div class="SecondEn">{{objBindInfoRes.Vehicle_Sletter_En}}</div>
                                                            <div class="ThirdEn">{{objBindInfoRes.Vehicle_Tletter_En}}</div>
                                                        </span>
                                                    </div>
                                                </label>
                                            </div>    
                                        </div>
                                    
                                </div>
                            </div>
                        </div> 
                        
    
                        <div class="row">
                            <hr class="hr" style="border-top: 2px solid #d6d6d6;margin-top:30px;"/>
                        </div>
                        <div class="row">    
                            <div class="btnsgroupupgrade">
                                <button class="btn btn-primary" name="btnPrev" id="btnPrev" (click)="goPrev()">{{'Prev'|translate }}</button>
                                <button class="btn btn-primary" name="btnNext" id="btnNext" (click)="saveProposal()">{{'Next'|translate }}</button>
                            </div>  
                        </div>    
                    </div>
                </div>
            </div>
        </div>


        
    </div>
    <div class="clears"></div>    
    <!-- Additional Comp Covers -->
    <div class="modal fade" id="AdditionalCoversModal" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog">    
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">    
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title logins">{{'Additional Comprehensive Covers' | translate}}</h4>
                </div>
                <div class="modal-body">    
                    <div class="ComprensivePremium">
                        <form #tplCoverForm="ngForm">
                            <table class="table table-striped tabledesign">
                                <thead>
                                    <tr>
                                        <th>{{'S.No' | translate}}</th>
                                        <th>{{'Cover Description' | translate}} </th>
                                        <th style="min-width:130px">{{'Total Price' | translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let addcover of objCheckEligibilityRes.ADDITIONAL_COVERS">
                                        <td> 
                                            <input id="txtSelected" name="txtSelected" type="checkbox"  style="zoom:1.3"
                                            (change)="AdditionalCoversCheck($event,addcover.CoverCode)" [checked]="addcover.IsMandatory" />
                                        </td>
                                        <td>{{ Lng=="en"?addcover.CoverDesc_En: addcover.CoverDesc_Ar }}</td>
                                        <!-- <td>{{ Lng=="en"?addcover.CoverDescription_Eng:addcover.CoverDescription_Ar }}</td> -->
                                        <td>{{ addcover.Amount | number : '1.2-2' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="Actionsection">
                                <div class="Actions">
                                    <div class="btn-group">    
                                        <button type="button" class="btn btn-primary btns procced" data-dismiss="modal">{{'Proceed'|translate}}</button>    
                                    </div>
                                </div>
                            </div>
                        </form>    
                    </div>
                </div>    
            </div>
        </div>    
    </div>
    <!-- Additional TPL Covers -->


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/UpgradePremiumInfo/UpgradePremiumInfo.html